<script>
    export default {
        methods: {
            getUrl(key) {
                const {urls} = window.Valle;

                return urls[key];
            },

            getTranslation(key) {
                const {translations} = window.Valle;
                return translations[key] || key;
            },

            objectifyQueryString(url) {
                let _url = new URL(url);
                let _params = new URLSearchParams(_url.search);
                return Array.from(_params.keys()).reduce((sum, value) => {
                    return Object.assign({[value]: _params.get(value)}, sum);
                }, {});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/mixins/siteConfig.vue